import Container from "@mui/material/Container";
import { Outlet } from "react-router";
import DashboardLayout from "../DashboardLayout/DashboardLayout";
import InternalError from "../Errors/InternalError";
import NoAccess from "../Errors/NoAccess";
import Loading from "../Loading";
import useSession from "../useSession/useSession";

const SiriusSecurePage: React.FC = () => {
  const { data: session, isLoading, isError } = useSession();

  if ((session?.SiriusUserGroups?.length ?? 0) > 0) {
    return <Outlet />;
  }

  if (isLoading) {
    return <Loading />;
  }
  if (isError) {
    return <InternalError />;
  }
  return (
    <DashboardLayout>
      <Container maxWidth={false}>
        <NoAccess />
      </Container>
    </DashboardLayout>
  );
};

export default SiriusSecurePage;
